export const StateKey = 'globalState';

export interface State {
  readonly sic: string;
}

export const initialState: State = {
  sic: '',
};
